const resumeData = {
  name: "James Davey",
  location: "San Francisco, CA",
  email: "james.t.davey@gmail.com",
  phoneNumber: "(415) 307-8703",
  summary:
    "Digital Accessibility Expert (DHS Trusted Tester) skilled at simplifying complex accessibility concepts and guiding teams to implement practical, effective solutions. Extensive experience in front-end web development and WCAG conformance, with a strong focus on enabling developers and designers to build accessible, user-friendly interfaces.",
  workExperiences: [
    {
        dates: "1/2026 - Present",
        company: "Apple",
        title: "Web Accessibility Engineer (Contract)",
        responsibilities: [
          "Write design reviews and engineering requirements for projects across the high-traffic Apple Online Store, upholding Apple’s high standards as a global leader in accessibility.",
          "Act as a liaison between engineering, design, and content teams to resolve complex issues and incorporate accessibility into product development.",
          "Prioritize and provide remediation guidance for a high volume of accessibility issues, using internal Apple tools to track work and deliver clear code and design recommendations.",
          "Write and review production code, open pull requests, and review accessibility fixes submitted by other developers."
        ]
    },
    // {
    //   dates: "7/2025 - 1/2026",
    //   company: "Miles Partnership",
    //   title: "Senior Digital Accessibility Specialist",
    //   responsibilities: [
    //     "Oversaw accessibility testing and remediation for 50+ high-traffic tourism websites, including many official city and state destinations, ensuring WCAG 2.2 compliance.",
    //     "Wrote articles on accessibility in the travel and tourism space, helping raise awareness and shape best practices across the industry.",
    //     // "Prioritize and manage large volumes of accessibility fixes, providing clear code and design recommendations in a fast-paced production environment.",
    //     "Collaborated with design and development teams to build accessibility into new projects, adding detailed annotations in Figma and QA-ing implemented fixes.",
    //   ]
    // },
    {
      dates: "6/2022 - 9/2024",
      company: "Paramount",
      title: "Senior Accessibility Architect (Contract)",
      responsibilities: [
        "Led accessibility remediation efforts and created comprehensive requirements for Pluto TV’s Web, Roku, and Android TV platforms, achieving significant improvements across new and existing components.",
        "Managed backlogs and led meetings with stakeholders to prioritize and resolve accessibility bugs and tasks.",
        // "Reviewed and annotated design prototypes, ensuring WCAG 2.2 standards were met prior to development.",
        "Defined and documented new text-to-speech standards, improving screen reader experiences across multiple TV platforms.",
        "Oversaw accessibility compliance for Paramount’s extensive network of refreshed brand sites, including MTV, Showtime, Nick, and several others.",
      ]
    },
    {
      dates: "8/2021 - 5/2022",
      company: "Lunchbox Technologies",
      title: "Senior Accessibility Engineer",
      responsibilities: [
        "Managed a large backlog of accessibility-related Jira tickets, providing detailed descriptions and solutions for engineering teams.",
        "Planned and executed remediation for high-priority sites, evaluating defects by impact, severity, and visibility across platforms.",
        "Wrote and pushed React code to fix accessibility issues, working directly with teams to get fixes deployed.",
      ],
    },
    {
      dates: "1/2021 - 7/2021",
      company: "CVS Health",
      title: "Accessibility Engineer Lead (Contract)",
      responsibilities: [
        "Coordinated and executed accessibility testing, remediation, and educational initiatives across multiple internal product teams.",
        "Improved accessibility in the component library by advising designers, supporting developers, and writing usage guidelines for inclusive applications.",
        "Established and enforced internal standards for accessible data visualization, including grids, charts, graphs, and data tables.",
      ],
    },
    // {
    //   dates: "7/2020 - 1/2021",
    //   company: "Kaiser Permanente",
    //   title: "Accessibility Design Specialist (Contract)",
    //   responsibilities: [
    //     "Conducted thorough design reviews and risk assessments for Kaiser’s high-traffic web components, ensuring accessibility for millions of users.",
    //     "Partnered with design teams to optimize accessibility and usability during the design phase, streamlining handoff to developers.",
    //     "Enhanced Kaiser’s design system documentation with new accessibility guidelines, maintaining high standards for industry-leading healthcare design.",
    //   ],
    // },
    {
      dates: "3/2019 - 1/2021",
      company: "Level Access",
      title: "Senior Accessibility Analyst",
      responsibilities: [
        //and showcase their accessibility awareness.
        "Performed comprehensive accessibility audits to ensure compliance with legal standards, guiding organizations to minimize digital risk.",
        "Managed long-term projects and cultivated strong client relationships, resulting in significant sales growth and service renewals.",
        // "Led remediation projects to achieve WCAG compliance, offering guidance from strategic direction to detailed code-level recommendations.",
        "Authored VPAT documents and conducted training sessions for developers and designers across Fortune 500 companies.",
        "Served as an Accessibility Design Specialist on a Kaiser Permanente contract, conducting in-depth design reviews for high-traffic web components and guiding UX teams on accessibility best practices.",
      ],
    },
    // {
    //   dates: "2017 - 2019",
    //   company: "Freelance",
    //   title: "Accessibility Web Developer",
    //   // summary:
    //   //   'Designed and launched web applications using modern front-end technology for businesses and personal commissions.',
    //   responsibilities: [
    //     "Built accessible websites using VanillaJS and JavaScript frameworks and libraries such as React, Mongoose, and Express with Node.js.",
    //     "Implemented advanced JavaScript concepts such as promises, async/await, callbacks, recursion, and closures.",
    //   ],
    // },
    // {
    //   dates: '2016 - 2018',
    //   company: 'Orange Photography',
    //   title: 'Digital Tech',
    //   // summary:
    //   //   'Responsible for designing photo templates, configuring image software, and supporting a team of photographers, videographers, and technicians.',
    //   responsibilities: [
    //     // 'Edited, organized, and optimized digital assets for online and print delivery in large volumes.',
    //     'Designed photo templates, configured image software, and supported a team of photographers, videographers, and technicians.',
    //     'Wrote documentation for software, camera, and lighting of complex studio setups, streamlining the creation of marketable photo products.',
    //   ],
    // },
  ],
  education: {
    school: "University of California, Davis",
    degree: "B.A. in Film and Technocultural Studies (2014)",
  },
  technicalSkills: [
    "WCAG",
    "ADA",
    "Section 508",
    "Assistive Technology",
    "HTML",
    "CSS",
    "JavaScript",
    "React",
    "Git",
    "VS Code",
    "Figma",
    "Jira",
    "Confluence",
    "Notion",
  ],
};

export default resumeData;
